import { Text } from '@mantine/core';
import { SortTagStyles } from '@dealstack/frontend/shared/components/SortTag/SortTag.styles.tsx';

interface Props {
	label: string | number;
}

export const SortTag = ({ label }: Props) => {
	return (
		<SortTagStyles>
			<Text fz="sm" c="dark.4" className="sort-number">
				#{label}
			</Text>
		</SortTagStyles>
	);
};
